export default __webpack_public_path__ + "static/media/covid.b34c4275.svg";